import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { Compass, MapPin, CalendarCheck, BookOpen, Search } from "lucide-react";

export default function NotFound() {
  const links = [
    { to: "/seniorcar", label: "Scopri SENIORCAR", icon: Compass },
    { to: "/rivenditori", label: "Trova un rivenditore", icon: MapPin },
    { to: "/offerta", label: "Prenota Online", icon: CalendarCheck },
    { to: "/guide", label: "Centro Mobilità Senior", icon: BookOpen },
    { to: "/cerca", label: "Cerca nel sito", icon: Search },
  ];
  return (
    <>
      <Seo title="Pagina non trovata" noindex />
      <section className="max-w-2xl mx-auto px-4 sm:px-6 py-24 text-center">
        <p className="text-7xl font-extrabold" style={{ color: "var(--sc-emerald)", fontFamily: "Outfit" }}>404</p>
        <h1 className="mt-4 text-2xl sm:text-3xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>Pagina non trovata</h1>
        <p className="mt-3 text-lg text-slate-600">La pagina che cerchi non esiste o è stata spostata. Ecco alcune destinazioni utili:</p>
        <div className="mt-8 grid sm:grid-cols-2 gap-3">
          {links.map((l) => {
            const Ic = l.icon;
            return <Link key={l.to} to={l.to}><Button variant="outline" className="w-full h-14 justify-start gap-3 text-base font-semibold border-2"><Ic size={20} className="text-emerald-700" /> {l.label}</Button></Link>;
          })}
        </div>
      </section>
    </>
  );
}
